import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-manufacturing-custom-brand',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './manufacturing-custom-brand.html',
  styleUrl: './manufacturing-custom-brand.scss',
})
export class ManufacturingCustomBrand {

}
